import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";

import * as api from "../../../services/api";

import {useFeedbackTools} from "../../../components/FeedbackTools";
import {OptionalContent} from "../../../components/OptionalContent";
import Page from "../../../layouts/Main/Page";

import RequestsList from "./RequestsList";

const FilteredRequests = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [totalRequests, setTotalRequests] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();
    let navigate = useNavigate();
    let {ruleId} = useParams();

    useEffect(() => {

        const loadRequests = async () => {
            try {
                const response = await api.FilterRules.getFilteredRequests(ruleId);
                setFilteredRequests(response["requests"]);
                setTotalRequests(response["totalRequests"]);
            } catch (e) {
                showErrorNotification(e);
            }
            setIsLoading(false);
        };
        loadRequests();
    }, [ruleId, showErrorNotification]);

    const handleLoadMore = async () => {
        setIsLoadingMore(true);
        try {
            const nextPage = currentPage + 1
            const response = await api.FilterRules.getFilteredRequests(ruleId, nextPage);
            setFilteredRequests(filteredRequests.concat(response["requests"]));
            setCurrentPage(nextPage)
        } catch (e) {
            showErrorNotification(e);
        }
        setIsLoadingMore(false);
    };

    const handleResend = async (requestId) => {
        try {
            await api.FilterRules.resendFilteredRequests(ruleId, requestId);
            setFilteredRequests(filteredRequests.map(x => x.id === requestId ? {
                ...x,
                numberOfSend: x.numberOfSend + 1
            } : x));
            showSuccessNotification("Richiesta inviata correttamente");
        } catch (e) {
            showErrorNotification(e);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Page title="Richieste filtrate" loading={isLoading} onBack={handleGoBack}>
            <OptionalContent hasContent={filteredRequests.length > 0}
                             noContentMessage="Nessuna richiesta è stata filtrata"
                             showIcon={true}>
                <RequestsList requests={filteredRequests}
                              totalRequests={totalRequests}
                              enableLoadMore={filteredRequests.length < totalRequests}
                              isLoadingMore={isLoadingMore}
                              onLoadMore={handleLoadMore}
                              onRequestResend={handleResend}/>
            </OptionalContent>
        </Page>
    )
};

export default FilteredRequests;